module.exports = __webpack_public_path__ + "img/02b-15px_15px.81c55f31.png";